import { getRandomString } from "../utils/string";

import Color from "./color";
import ColorDefinition from "./ColorDefinition";
import Model from "./model";

export const NOTE_TYPE_NAME_MAX_CHARACTERS = 20;

export interface NoteTypeData {
    name?: string;
    _id?: string;
    color?: ColorDefinition;
    organizationNoteType?: boolean;
    newNoteType?: boolean;
}

export default class NoteType extends Model {
    name?: string;
    _id?: string;
    color?: Color;
    organizationNoteType?: boolean;
    newNoteType?: boolean;

    static None = new NoteType({
        _id: "None",
        name: "None",
        color: new Color({
            name: "gandalf", r: 151, g: 145, b: 151
        })
    });

    constructor(noteType: NoteTypeData) {
        super();

        const {
            _id = `newNoteTypeId-${getRandomString()}`,
            name,
            color = new Color({
                name: "yellow", r: 254, g: 207, b: 51, a: 1
            }),
            organizationNoteType = false,
            newNoteType = false
        } = noteType;

        this._id = _id;
        this.name = name;
        this.color = new Color(color);
        this.organizationNoteType = organizationNoteType;
        this.newNoteType = newNoteType;
    }
}
